import React, {Component} from 'react';
import { Link } from 'react-router-dom';

// Layout
import Header from "../layout/header2";
import Footer from "../layout/footer";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";
import testPic1 from "../../images/testimonials/pic1.jpg";
import testPic2 from "../../images/testimonials/pic2.jpg";
import testPic3 from "../../images/testimonials/pic3.jpg";
import testPic4 from "../../images/testimonials/pic4.jpg";
import testPic5 from "../../images/testimonials/pic5.jpg";

import blogGridPic1 from "../../images/blog/grid/pic1.jpg";
import blogGridPic2 from "../../images/blog/grid/pic2.jpg";
import blogGridPic3 from "../../images/blog/grid/pic3.jpg";
import blogGridPic4 from "../../images/blog/grid/pic4.jpg";
import blogGridPic5 from "../../images/blog/grid/pic5.jpg";

 

// Blog Content
const content = [
	{ 
		thumb: blogGridPic1,
		authorPic: testPic1,
		title: "Hospital Mac Norte y Sur",		
		url: "https://hospitalesmac.com/",
	},
	{ 
		thumb: blogGridPic2,
		authorPic: testPic2,
		title: "Médica Norte",		
		url: "https://www.medica-norte.com.mx/",
	},
	{ 
		thumb: blogGridPic3,
		authorPic: testPic3,
		title: "Medisur",		
		url: "https://goo.gl/maps/bVdfcLrT4wgfF78g9",
	},
	{ 
		thumb: blogGridPic4,
		authorPic: testPic4,
		title: "Clinica La Asunción",		
		url: "https://www.facebook.com/clinicaasuncion.ags/",
	},
	{ 
		thumb: blogGridPic5,
		authorPic: testPic5,
		title: "Biomaterna",		
		url: "https://www.biomaterna.com.mx/",
	}
]

class BlogGrid extends Component{
	
	render(){
		return (
			<>
				
				<Header />
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Hospitales para su Atención</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Home</Link></li>
											<li className="breadcrumb-item active" aria-current="page">Hospitales</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								{content.map((item) =>(
									<div className="col-xl-4 col-md-6">
										<div className="blog-card mb-30">
											<div className="post-media">
												<img src={item.thumb} alt=""/>
											</div>
											<div className="post-info">
 
												<h4 className="post-title" onClick={()=> window.open(item.url, "_blank")}>{item.title}</h4>		
												<button className="btn btn-outline-primary btn-sm" onClick={()=> window.open(item.url, "_blank")}>Saber mas <i className="btn-icon-bx fas fa-chevron-right"></i></button>		
											</div>
										</div>							
									</div>
								))}
							</div>
						</div>
					</section>
					
				</div>
				
				<Footer />
				
			</>
		);
	}
}

export default BlogGrid;
